import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TerceroTelefono } from '../../../../_models/tercero-telefono';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { ListaItem } from '../../../../_models/lista-item';
import { ListaService } from '../../../../_services/lista.service';
import { forkJoin } from 'rxjs';
import { TiposUsoTelefono, TipoTelefonos } from '../../../../_enums/enum';
import { TerceroService } from '../../../../_services/tercero.service';
import { NavService } from '../../../../_services/_nav.service';
import { UsuarioExtensionTelefonica } from '../../../../_models/usuario-extension-telefonica';
import { UsuarioExtensionTelefonicaService } from '../../../../_services/usuario-extension-telefonica.service';
import { AutenticacionService } from '../../../../_services/autenticacion.service';
import { LlamadaService } from '../../../../_services/llamada.service';

@Component({
  selector: 'app-perfil-crezcamos-telefonos',
  templateUrl: './perfil-crezcamos-telefonos.component.html',
  styleUrls: ['./perfil-crezcamos-telefonos.component.scss']
})
export class PerfilCrezcamosTelefonosComponent implements OnInit {

  @Input() informacionPerfil: any;
  nombreTercero: string;
  listaTelefonos: TerceroTelefono[] = [];
  acceso: boolean = false;
  cargando: boolean = true;
  formulario: FormGroup;
  listaTiposSuministrosTelefonos: SelectItem[] = [];
  submitted: boolean = false;
  tipoTelefonoCelular: ListaItem;
  tipoUso: ListaItem;
  columnasTelefonos: any[];
  usuExtension: UsuarioExtensionTelefonica;
  llamando: boolean = false;

  constructor(
    private fb: FormBuilder,
    private listasService: ListaService,
    private terceroService: TerceroService,
    private navService: NavService,
    private usuExtensionTelefonicaServicio: UsuarioExtensionTelefonicaService,
    private autServicio: AutenticacionService,
    private llaServicio: LlamadaService,
  ) { }

  async ngOnInit() {
    console.log(this.informacionPerfil);
    if (this.informacionPerfil && this.informacionPerfil.secciones) {
      this.acceso = this.tieneAcceso(this.informacionPerfil.secciones);
    } else {
      this.acceso = false;
      return
    }

    this.usuExtension = await this.usuExtensionTelefonicaServicio.obtenerPorIdUsuarioEnabled(this.autServicio.obtenerIdUsuarioLogueado()).toPromise();

    this.nombreTercero = this.informacionPerfil && this.informacionPerfil.nombre ? this.informacionPerfil.nombre : null;
    this.listaTelefonos = this.informacionPerfil && this.informacionPerfil.tercerosTelefonos ? this.informacionPerfil.tercerosTelefonos : null;

    await this.inicializarFormulario();
    await this.cargarInformacionFormulario();
    await this.setColumnasTablas();
    this.cargando = false;
  }

  tieneAcceso(array) {
    return array.includes("CLITEL");
  }

  inicializarFormulario() {
    this.formulario = this.fb.group({
      numeroTelefono: [null, [Validators.required]],
      idTipoSuministro: [null, [Validators.required]],
    });
    this.cargando = false;
  }

  get fControls() {
    return this.formulario.controls;
  }

  async cargarInformacionFormulario() {
    try {
      const {
        listaTiposSuministrosTelefonos,
        listaTiposTelefonos,
        listaTiposUsosTelefonos,
      } = await forkJoin({
        listaTiposSuministrosTelefonos: this.listasService.getMasterDetails(
          "ListasTiposSuministrosTelefonos"
        ),
        listaTiposTelefonos: this.listasService.getMasterDetails(
          "ListasTiposTelefonos"
        ),
        listaTiposUsosTelefonos: this.listasService.getMasterDetails(
          "ListasTiposUsosTelefonos"
        ),
      }).toPromise();

      this.listaTiposSuministrosTelefonos = listaTiposSuministrosTelefonos.map(
        (s: ListaItem) => ({
          label: s.nombre,
          value: s.idLista,
        })
      );

      this.tipoTelefonoCelular = listaTiposTelefonos.find(
        (item) => item.codigo === TipoTelefonos.CELULAR
      );
      this.tipoUso = listaTiposUsosTelefonos.find(
        (item) => item.codigo === TiposUsoTelefono.PERSONAL
      );
    } catch (error) {
      console.error("Error al cargar la información del formulario:", error);
    }
  }

  setColumnasTablas() {
    this.columnasTelefonos = [
      {
        field: "nombre",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_TELEFONO"),
        sort: false,
      },
      {
        field: "acciones",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_SUMINISTRADOPOR"),
        sort: false,
      },
      {
        field: "acciones",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_FECHA"),
        sort: false,
      },
      {
        field: "acciones",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_ACTIVO"),
        sort: false,
      },
      {
        field: "acciones",
        header: this.navService.buscarMensaje("PERFILCREZCAMOS.LBL_ACCIONES"),
        sort: false,
      }
    ];
  }

  llamar(telefono: TerceroTelefono) {
    console.log('extension: ', this.usuExtension);
    console.log('telefono: ', telefono);
    if ( this.usuExtension ) {
      console.log("Llamando");
      this.llamando = true;
      const numLlamar = telefono.numeroTelefono ? telefono.numeroTelefono.toString().replace( /[^0-9.]/gi, '' ) : '';
      this.usuExtension.codigoSistema
      this.llaServicio.llamarValidacion( this.autServicio.obtenerIdUsuarioLogueado(), numLlamar, this.usuExtension.codigoSistema ).subscribe( llamada => {
        console.log(llamada)
        this.llamando = false;
      }, error => {
        console.log(error)
        this.navService.setMesage( 0, {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navService.buscarMensaje( 'RADICACION.MSG_ERRORLLAMAR' )
        } );
        this.llamando = false;
      } );
    } else {
      this.navService.setMesage( 0, {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navService.buscarMensaje( 'TELEFONOS.MSG_NOTIENEEXTENSION' )
      } );
    }
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formulario.invalid) {
      console.log("Formulario inválido");
      return;
    } else {
      this.cargando = true;

      const formulario = this.formulario.getRawValue();
      console.log(formulario);

      const body = {
        numeroTelefono: formulario.numeroTelefono,
        idTipoSuministro: formulario.idTipoSuministro,
        idTipoTelefono: this.tipoTelefonoCelular.idLista,
        idTipoUso: this.tipoUso.idLista,
        indicadorPrincipal: false,
        indicadorHabilitado: true,
        idTercero: this.informacionPerfil.idTercero
      };

      this.terceroService.crearTelefono(body).subscribe(async respuesta => {
        if (respuesta) {
          console.log(respuesta);
          if (respuesta.mensaje) {
            this.mostrarMensaje("info", "LBL_INFORMACION", respuesta.mensaje);
            this.cargando = false;
          } else {
            this.navService.setMesage(1);
            this.listaTelefonos = respuesta.tercerosTelefonos;
            this.limpiarFormulario();
            this.cargando = false;
          }
        } else {
          this.cargando = false;
        }
      }, error=> {
        console.log(error);
        this.cargando = false;
      });
    }
  }

  limpiarFormulario() {
    this.formulario.reset();
    this.submitted = false;
  }

  mostrarMensaje(
    severity: string,
    summary: string,
    detail: string
  ) {
    this.navService.setMesage(0, {
      severity,
      summary: this.navService.buscarMensaje(summary),
      detail: this.navService.buscarMensaje(detail),
    });
  }
}
